import { render, staticRenderFns } from "./AddSetting.vue?vue&type=template&id=aa3c9436&"
import script from "./AddSetting.vue?vue&type=script&lang=js&"
export * from "./AddSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports